export const DESIGN_DEMOS = {
  ICON_DESIGNS_CONTAINER: 'icon-designs-container',
  ICON_DESIGNS_NOTIFICATIONS_NO_NEW: 'icon-designs-notifications-no-new',
  ICON_DESIGNS_COMMENTS_NO_NEW: 'icon-designs-comments-no-new',
  ICON_DESIGNS_NOTIFICATIONS_NEW: 'icon-designs-notifications-new',
  ICON_DESIGNS_COMMENTS_NEW: 'icon-designs-comments-new',
  ICON_DESIGNS_CREATE_PROJECT: 'icon-designs-create-project',
  ICON_DESIGNS_INCREMENT_BUTTON: 'icon-designs-increment-button',
  ICON_DESIGNS_DECREMENT_BUTTON: 'icon-designs-decrement-button',
  ICON_DESIGNS_ACTIVITIES: 'icon-designs-activities',
  ICON_DESIGNS_NODES: 'icon-designs-nodes',
  DESIGN_COMPONENTS_CONTAINER: 'design-components-container',
  TRUNCATED_TYPOGRAPHY_NO_HOVER: 'truncated-typography-no-hover',
  TRUNCATED_TYPOGRAPHY_HOVER_BOLD: 'truncated-typography-hover-bold',
  TRUNCATED_TYPOGRAPHY_HOVER_NORMAL: 'truncated-typography-hover-normal',
  TRUNCATED_TYPOGRAPHY_INHERIT_FALSE: 'truncated-typography-inherit-false',
  DESIGN_SYSTEM_CONTAINER: 'design-system-container',
  DESIGN_SYSTEM_TABS: 'design-system-tabs',
  DESIGN_SYSTEM_ICONS_TAB: 'design-system-icons-tab',
  DESIGN_SYSTEM_CANVAS_TAB: 'design-system-canvas-tab',
  DESIGN_SYSTEM_TABLE_TAB: 'design-system-table-tab',
  DESIGN_SYSTEM_GANTT_TAB: 'design-system-gantt-tab',
  DESIGN_SYSTEM_DESIGN_COMPONENTS_TAB: 'design-system-design-components-tab'
} as const;
